<template>
  <div
    class="widget-preview"
    v-if="visible"
  >
    <div
      class="closeable"
      @click="closePreview"
    >
      <i class="h-icon-close_f"></i>
    </div>
    <div
      class="prev-btn"
      @click="prevItem"
      :class="{disabled: prevDisabled}"
    >
      <i class="h-icon-angle_left"></i>
    </div>
    <div
      class="next-btn"
      @click="nextItem"
      :class="{disabled: nextDisabled}"
    >
      <i class="h-icon-angle_right"></i>
    </div>
    <div class="preview-content">
      <widget-homepage
        v-if="nowItem"
        :comType="nowItem.type"
        :comSubType="nowItem.subType"
        :widgetId="nowItem.id"
        :preview="true"
        :url="nowItem.url"
      >
      </widget-homepage>
    </div>
  </div>
</template>

<script>
import widgetHomepage from 'components/widget-homepage/widget-homepage'
export default {
  name: 'widget-preview',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      default: () => {
        return []
      }
    },
    index: {
      type: Number,
      default: 0
    }
  },
  computed: {
    nowItem () {
      if (this.data.length === 0) {
        return null
      } else {
        return this.data[this.index]
      }
    },
    prevDisabled () {
      return this.index === 0
    },
    nextDisabled () {
      return this.index === this.data.length - 1
    }
  },
  methods: {
    closePreview () {
      this.$emit('update:visible', false)
    },
    prevItem () {
      if (this.index - 1 < 0) return
      this.$emit('update:index', this.index - 1)
    },
    nextItem () {
      if (this.index + 1 >= this.data.length) return
      this.$emit('update:index', this.index + 1)
    }
  },
  components: {
    widgetHomepage
  }
}
</script>

<style scoped lang="less" rel="stylesheet/less">
.widget-preview {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(25, 25, 25, 0.7);
  .closeable {
    width: 36px;
    height: 36px;
    position: absolute;
    top: 30px;
    right: 30px;
    cursor: pointer;
    i {
      font-size: 36px;
      color: rgba(2555, 255, 255, 1);
    }
  }
  .next-btn,
  .prev-btn {
    i {
      font-size: 56px;
      color: rgba(2555, 255, 255, 0.8);
    }
  }
  .prev-btn {
    width: 58px;
    height: 56px;
    position: absolute;
    left: 32px;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
  }
  .next-btn {
    width: 58px;
    height: 56px;
    position: absolute;
    right: 32px;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
  }
  .preview-content {
    position: absolute;
    left: 112px;
    right: 112px;
    top: 48px;
    bottom: 48px;
    background: #f5f5f5;
  }
  .disabled {
    cursor: not-allowed;
  }
}
</style>
